import { createEvent, restore } from 'effector';

export const setTitle = createEvent<string>();
export const $title = restore(setTitle, ' ');
